import { ConfigService } from '@/shared/services/config.service';

/**
 * Namespaces a localStorage key with the app id (`tenko.products.list.view`),
 * so two dashboards served from the same origin never read each other's state.
 */
export const storageKey = (key: string): string =>
  `${ConfigService.getInstance().getOrThrow('appId')}.${key}`;
